import { Button, FormInput, FormWrapper } from "@odmonorepo/core-components";
import { Card, Stack } from "react-bootstrap";
import { unifiedApiClient } from "merchant-api/unified";
import { ErrorAlert } from "./ErrorAlert";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";

interface OTPasswordNotifyRes {
  emailMasked: string;
  key: string;
  error?: string;
}

interface OTPRequestError {
  status?: number;
  data?: unknown;
}

interface OTPNotifyRequest {
  email?: string;
  key?: string;
}

interface Props {
  onNotify?: (data: OTPasswordNotifyRes) => void;
}

const schema = yup.object({
  email: yup.string().email('Enter your email address in this format: name@example.com').required('Enter your email address.'),
});

const notifyOTP = async (data: OTPNotifyRequest) => {
  const result = await unifiedApiClient.POST('/public/otp/notify', { body: data } as never);

  if (!result.response.ok) throw { status: result.response.status, data: result.error } satisfies OTPRequestError;

  return result.data as unknown as OTPasswordNotifyRes;
};

export const EmailCode = ({onNotify}: Props) => {
  const { mutate: sendOTP, isPending: notifying, error } = useMutation<OTPasswordNotifyRes, OTPRequestError, OTPNotifyRequest>({
    mutationFn: notifyOTP,
    throwOnError: false,
    onSuccess: onNotify,
  });

  return (
    <Card style={{ maxWidth: '600px' }} className='p-5 w-100'>
      <ErrorAlert status={error?.status} />
      <FormWrapper onSubmit={data => sendOTP(data)} schema={schema}>
        <Stack gap={5}>
          <div className="h4">To continue, please verify your email address.</div>
          <FormInput type="email" name="email" useYupErrors/>
          <Button type="submit" loading={notifying} loadingText="Sending...">Submit</Button>
        </Stack>
      </FormWrapper>
    </Card>
  );
};
export default EmailCode;
